export default __webpack_public_path__ + "static/3-7a31a06cfd03cf66168d4b70528c2edc.png";